import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SameHeightDirective } from './sameHeight.directive';

@NgModule({
  declarations: [SameHeightDirective],
  exports: [SameHeightDirective],
  imports: [CommonModule]
})
export class DirectivesModule {}
